<template>
  <v-flex xs12 px-2 style="position: relative">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs2>
          <v-card class="d-inline-block" style="width: 95%">
            <v-navigation-drawer floating permanent stateless value="true">
              <v-list dense>
                <v-list-tile :to="{ path: '/admin/organizations' }">
                  <v-list-tile-action><v-icon>public</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Organizations</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/organizations-users' }">
                  <v-list-tile-action><span></span></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Organizations Users</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/organizations-projects' }">
                  <v-list-tile-action><span></span></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Organizations Projects</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/organizations-users-projects' }">
                  <v-list-tile-action><span></span></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Organizations Users Projects</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/projects' }">
                  <v-list-tile-action><v-icon>dashboard</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Projects</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/projects-plans' }">
                  <v-list-tile-action><span></span></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Projects Plans</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/users' }">
                  <v-list-tile-action><v-icon>people</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Users</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/roles' }">
                  <v-list-tile-action><v-icon>fingerprint</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Roles</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/roles-privileges' }">
                  <v-list-tile-action><span></span></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Roles Privileges</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/privileges' }">
                  <v-list-tile-action><v-icon>device_hub</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Privileges</v-list-tile-title></v-list-tile-content>
                </v-list-tile>

                <v-list-tile :to="{ path: '/admin/plans' }">
                  <v-list-tile-action><v-icon>event</v-icon></v-list-tile-action>
                  <v-list-tile-content><v-list-tile-title>Plans</v-list-tile-title></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
          </v-card>
        </v-flex>

        <v-flex xs10>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({getRoleByName: 'getRoleByName', getRoles: 'getRoles'})
  },
  mounted () {
    if (!this.isLoggedIn) {
      this.$router.push({ path: '/market' })
    } else if (this.currentUser && this.getRoles.length > 0 && this.currentUser.defaultRoleId !== this.getRoleByName('MASTER_ROLE').id) {
      this.$router.push({path: '/market'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue